import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	routes: [{
			path: '/',
			redirect: '/login'
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import('../views/Login.vue')
		},
		{
			path: '/',
			component: () => import('../views/Layout.vue'),
			children: [{
					path: 'assignment',
					name: 'Assignment',
					component: () => import('../views/Assignment.vue')
				},
				{
					path: 'digital-human',
					name: 'DigitalHuman',
					component: () => import('../views/DigitalHuman.vue')
				},
				{
					path: 'face-swap',
					name: 'FaceSwap',
					component: () => import('../views/FaceSwap.vue')
				},
				{
					path: 'dubbing',
					name: 'Dubbing',
					component: () => import('../views/Dubbing.vue')
				},
				{
					path: 'subtitle',
					name: 'Subtitle',
					component: () => import('../views/Subtitle.vue')
				},
				{
					path: 'material-assets',
					name: 'MaterialAssets',
					component: () => import('../views/MaterialAssets.vue')
				},
				{
					path: 'video-edit',
					name: 'VideoEdit',
					component: () => import('../views/VideoEdit.vue')
				},
				{
					path: 'video-mix',
					name: 'VideoMix',
					component: () => import('../views/VideoMix.vue')
				},
				{
					path: 'remove-watermark',
					name: 'RemoveWatermark',
					component: () => import('../views/RemoveWatermark.vue')
				},
				{
					path: 'admin',
					name: 'Admin',
					component: () => import('../views/Admin.vue')
				},
			]
		},
		{
			path: '/canvas',
			name: 'Canvas',
			component: () => import('../views/Canvas.vue')
		}
	]
})

router.beforeEach((to, from, next) => {
	const adminInfo = localStorage.getItem('adminInfo')
	if (to.path !== '/login') {
		if (!adminInfo) {
			next('/login')
		} else {
			next()
		}
	} else {
		if (adminInfo) {
			next('/assignment')
		} else {
			next()
		}
	}
})

export default router